export enum ImageProfile {
  Thumb = 'Thumb',
  Medium = 'Medium',
  Wide = 'Wide',
  Fit = 'Fit',
  Large = 'Large',
  Feature = 'Feature',
  Full = 'Full',
}